(function () {
  if (!document.body.hasAttribute('pt-2-ab-test')) return;

  var SHIELD_CHECK_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">' +
    '<path d="M13.3333 8.66667C13.3333 12 11 13.6667 8.22667 14.6333C8.08144 14.6825 7.92369 14.6802 7.78 14.6267C5 13.6667 2.66667 12 2.66667 8.66667V4C2.66667 3.82319 2.7369 3.65362 2.86193 3.5286C2.98695 3.40357 3.15652 3.33333 3.33333 3.33333C4.66667 3.33333 6.33333 2.53333 7.49333 1.52C7.63457 1.39933 7.81424 1.33303 8 1.33303C8.18576 1.33303 8.36543 1.39933 8.50667 1.52C9.67333 2.54 11.3333 3.33333 12.6667 3.33333C12.8435 3.33333 13.013 3.40357 13.1381 3.5286C13.2631 3.65362 13.3333 3.82319 13.3333 4V8.66667Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M6 8L7.33333 9.33333L10 6.66667" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var CHEVRON_LEFT_SVG =
    '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var CHEVRON_RIGHT_SVG =
    '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function extractImagesFromGpData(root) {
    var raw = root.getAttribute('gp-data');
    if (!raw) return [];

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return [];
    }

    var product = data && data.product;
    if (!product || !Array.isArray(product.images) || !product.images.length) return [];

    return product.images.map(function (src) {
      return { src: src, alt: product.title || '' };
    });
  }

  function extractImagesFromDom(root) {
    var seen = {};
    var images = [];

    root.querySelectorAll('.gp-gallery-image-item img').forEach(function (img) {
      var src = img.currentSrc || img.src;
      if (!src || seen[src]) return;
      seen[src] = true;
      images.push({ src: src, alt: img.alt || '' });
    });

    if (!images.length) {
      var heroImg = root.querySelector('.gp-featured-image-wrapper img');
      if (heroImg) {
        var heroSrc = heroImg.currentSrc || heroImg.src;
        if (heroSrc) images.push({ src: heroSrc, alt: heroImg.alt || '' });
      }
    }

    return images;
  }

  function extractImages(root) {
    var fromData = extractImagesFromGpData(root);
    if (fromData.length) return fromData;
    return extractImagesFromDom(root);
  }

  function buildBadge() {
    var badge = document.createElement('div');
    badge.className = 'pt2-media-gallery__badge';

    var icon = document.createElement('span');
    icon.className = 'pt2-media-gallery__badge-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = SHIELD_CHECK_SVG;
    badge.appendChild(icon);

    var text = document.createElement('p');
    text.className = 'pt2-media-gallery__badge-text';

    var line1 = document.createElement('span');
    line1.className = 'pt2-media-gallery__badge-line';
    line1.appendChild(document.createTextNode('Über '));
    var count = document.createElement('strong');
    count.textContent = window.PT2_REVIEW_COUNT;
    line1.appendChild(count);
    line1.appendChild(document.createTextNode(' Bewertungen'));

    var line2 = document.createElement('span');
    line2.className = 'pt2-media-gallery__badge-line';
    line2.textContent = 'bestätigen die Wirksamkeit';

    text.appendChild(line1);
    text.appendChild(line2);
    badge.appendChild(text);

    return badge;
  }

  function buildTrustBanner() {
    var wrapper = document.createElement('div');
    wrapper.className = 'pt2-media-gallery__trust';

    var pill = document.createElement('div');
    pill.className = 'pt2-media-gallery__trust-pill';
    if (window.PT2_TRUST_PILL_COLOR) {
      pill.style.background = window.PT2_TRUST_PILL_COLOR;
    }

    if (window.PT2_TRUST_ICON_URL) {
      var icon = document.createElement('img');
      icon.className = 'pt2-media-gallery__trust-icon';
      icon.src = window.PT2_TRUST_ICON_URL;
      icon.alt = '';
      icon.loading = 'lazy';
      pill.appendChild(icon);
    }

    var pillText = document.createElement('p');
    pillText.className = 'pt2-media-gallery__trust-pill-text';
    pillText.textContent = '15.381+ Katzen lieben den Snack';
    pill.appendChild(pillText);

    wrapper.appendChild(pill);

    var description = document.createElement('p');
    description.className = 'pt2-media-gallery__trust-description';
    description.textContent =
      'Tausende Katzenbesitzer bestätigen eine 98% hohe Akzeptanzrate der Patsli Snacks';
    wrapper.appendChild(description);

    return wrapper;
  }

  function buildProductPhoto() {
    var wrapper = document.createElement('div');
    wrapper.className = 'pt2-media-gallery__product-photo';

    var img = document.createElement('img');
    img.src = window.PT2_PRODUCT_PHOTO_URL;
    img.loading = 'lazy';
    img.alt = window.PT2_PRODUCT_TITLE || '';
    wrapper.appendChild(img);

    return wrapper;
  }

  function buildGallery(images) {
    var displayImages = images.slice();
    if (window.PT2_FIRST_IMAGE_OVERRIDE) {
      displayImages[0] = {
        src: window.PT2_FIRST_IMAGE_OVERRIDE,
        alt: displayImages[0] ? displayImages[0].alt : ''
      };
    }

    var root = document.createElement('div');
    root.className = 'pt2-media-gallery';

    var hero = document.createElement('div');
    hero.className = 'pt2-media-gallery__hero';
    root.appendChild(hero);

    var track = document.createElement('div');
    track.className = 'pt2-media-gallery__track';
    hero.appendChild(track);

    displayImages.forEach(function (image, index) {
      var slide = document.createElement('div');
      slide.className = 'pt2-media-gallery__hero-slide';
      slide.setAttribute('data-index', index);

      var img = document.createElement('img');
      img.className = 'pt2-media-gallery__hero-image';
      img.src = image.src;
      img.alt = image.alt;
      img.loading = index === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);

      if (index === 0) {
        if (window.PT2_REVIEW_COUNT > 0) slide.appendChild(buildBadge());
        if (window.PT2_PRODUCT_PHOTO_URL) slide.appendChild(buildProductPhoto());
      }

      track.appendChild(slide);
    });

    if (displayImages.length > 1) {
      var thumbs = document.createElement('ul');
      thumbs.className = 'pt2-media-gallery__thumbs';
      thumbs.setAttribute('role', 'list');

      displayImages.forEach(function (image, index) {
        var item = document.createElement('li');
        item.className = 'pt2-media-gallery__thumb-item';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'pt2-media-gallery__thumb' + (index === 0 ? ' is-active' : '');
        button.setAttribute('data-gallery-thumb', '');
        button.setAttribute('data-index', index);
        button.setAttribute('aria-label', 'Load image ' + (index + 1));

        var thumbImg = document.createElement('img');
        thumbImg.src = image.src;
        thumbImg.alt = '';
        thumbImg.loading = 'lazy';
        button.appendChild(thumbImg);

        if (index === 0 && window.PT2_PRODUCT_PHOTO_URL) {
          var thumbBadge = document.createElement('span');
          thumbBadge.className = 'pt2-media-gallery__thumb-badge';
          thumbBadge.setAttribute('aria-hidden', 'true');
          var thumbBadgeImg = document.createElement('img');
          thumbBadgeImg.src = window.PT2_PRODUCT_PHOTO_URL;
          thumbBadgeImg.alt = '';
          thumbBadgeImg.loading = 'lazy';
          thumbBadge.appendChild(thumbBadgeImg);
          button.appendChild(thumbBadge);
        }

        item.appendChild(button);
        thumbs.appendChild(item);
      });

      root.appendChild(thumbs);

      var prevButton = document.createElement('button');
      prevButton.type = 'button';
      prevButton.className = 'pt2-media-gallery__arrow pt2-media-gallery__arrow--prev';
      prevButton.setAttribute('aria-label', 'Previous image');
      prevButton.innerHTML = CHEVRON_LEFT_SVG;
      hero.appendChild(prevButton);

      var nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'pt2-media-gallery__arrow pt2-media-gallery__arrow--next';
      nextButton.setAttribute('aria-label', 'Next image');
      nextButton.innerHTML = CHEVRON_RIGHT_SVG;
      hero.appendChild(nextButton);

      function setActiveIndex(index) {
        thumbs.querySelectorAll('.pt2-media-gallery__thumb').forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
        });
        prevButton.disabled = index === 0;
        nextButton.disabled = index === displayImages.length - 1;
      }

      function goTo(index) {
        index = Math.max(0, Math.min(displayImages.length - 1, index));
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      }

      thumbs.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        goTo(parseInt(thumb.getAttribute('data-index'), 10));
      });

      prevButton.addEventListener('click', function () {
        goTo(Math.round(track.scrollLeft / track.clientWidth) - 1);
      });

      nextButton.addEventListener('click', function () {
        goTo(Math.round(track.scrollLeft / track.clientWidth) + 1);
      });

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          if (!track.clientWidth) return;
          var index = Math.round(track.scrollLeft / track.clientWidth);
          setActiveIndex(index);
        }, 100);
      });

      setActiveIndex(0);
    }

    root.appendChild(buildTrustBanner());

    return root;
  }

  function allInjected(galleries) {
    return Array.prototype.every.call(galleries, function (gallery) {
      return !!gallery.querySelector('.pt2-media-gallery');
    });
  }

  function inject() {
    var galleries = document.querySelectorAll('gp-product-images');
    if (!galleries.length) return false;
    if (allInjected(galleries)) return true;

    var images = [];
    for (var i = 0; i < galleries.length; i++) {
      images = extractImages(galleries[i]);
      if (images.length) break;
    }
    if (!images.length) return false;

    galleries.forEach(function (gallery) {
      if (gallery.querySelector('.pt2-media-gallery')) return;
      gallery.innerHTML = '';
      gallery.appendChild(buildGallery(images));
    });

    return true;
  }

  if (!inject()) {
    window.addEventListener('load', inject);
  }

  var observer = new MutationObserver(function () {
    inject();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
